import { hot } from 'react-hot-loader/root';
import Component from './persistentTable-redux';

export default hot(Component);
